import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GenericFormComponent } from '@app/helpers/generic-form-component';
import { ConstantsService } from '@app/services/constants.service';
import { DataService } from '@app/services/data.service';
import { EmployeeService } from '@app/services/employee.service';
import { HelpService } from '@app/services/help.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';

declare var $: any;

interface EmployeeProfileConfig {
  applications: number,
  views: number,
  profileCompleted: number,
  dateEdition: Date,
  preferences: number,
  profileValid: number,
  video: number,
  notificationPeriodicity: string
}

@Component({
  selector: 'app-navigation-bar-employee-config',
  templateUrl: './navigation-bar-employee-config.component.html',
  styleUrls: ['./navigation-bar-employee-config.component.css']
})
export class NavigationBarEmployeeConfigComponent extends GenericFormComponent {

  public employeeProfileCompletedAnim = 0;

  private interval: NodeJS.Timeout;

  public isLoadingSearch: boolean = true;

  public profileConfig: EmployeeProfileConfig = undefined;

  constructor(
    public userService: UserService,
    public constantsService: ConstantsService,
    private employeeService: EmployeeService,
    public helpService: HelpService,
    private dataService: DataService,
    private router: Router
  ) {
    super();
    this.createFormGroup();
  }

  createFormGroup() {
    this._formGroup = new UntypedFormGroup({
      employeeNotification: new UntypedFormControl("O0")
    });
  }



  getEmployee() {

    this.isLoadingSearch = true;

    if (this.interval) { clearInterval(this.interval); }

    if (!this.userService.isEmployee()) {
      this.isLoadingRequest = false;
      return;
    }

    this.employeeService.getEmployeeProfileConfig(this.userService.getIdEmployee()).toPromise().then(
      res => {

        if (res.status_code !== status_code.success) {
          this.isLoadingSearch = false;
          return;
        }

        this.profileConfig = res.profileConfig;

        this.isLoadingSearch = false;

        this.employeeNotification.setValue(this.profileConfig.notificationPeriodicity);


        setTimeout(() => { this.showAnim(); }, 100);

      },
      err => {
        console.log(err);
      }
    )
  }

  saveEmployeePreference() {

    this._formGroup.markAllAsTouched();

    if (!this._formGroup.valid || this.isLoadingRequest === true) return;

    var req = {
      _idEmployee: this.userService.getIdEmployee(),
      reqEmployee: {
        employeeNotification: this.employeeNotification.value === 'O1' || this.employeeNotification.value === 'O2' ? 1 : 0,
        employeeNotificationPeriodicity: this.employeeNotification.value
      }
    };

    this.employeeService.postEmployeePreferences(req).toPromise().then(
      res => {
        if (parseInt(res.status_code) === 0) {
          this.helpService.showToastSuccess();
          this.dataService.nextSharedData({ module: 'EmployeeFormUpdateComponent', property: 'notification', value: this.employeeNotification.value })
        }
        else {
          this.helpService.showToastError();
        }
      },
      () => {
        this.helpService.showToastError();
      }
    )
  }

  sendActionFormUpdate(property: string) {

    this.closeDropdownPreferences();

    if (!this.router.url.includes(this.constantsService.BASE_PATH_EMPLOYEE_EDIT)) {
      this.router.navigate([this.constantsService.BASE_PATH_EMPLOYEE_EDIT]);
    }

    this.dataService.nextSharedData({ module: 'EmployeeFormUpdateComponent', property })
  }

  get employeeNotification() { return this._formGroup.get('employeeNotification') as UntypedFormControl; }

  closeDropdownPreferences() {
    $("#dropdownMainMenuPS").dropdown("toggle");
  }

  showDropdown(event) {
    this.getEmployee();
  }

  showAnim() {

    if (this.interval) { clearInterval(this.interval) }

    var endVal = this.profileConfig.profileCompleted;

    this.employeeProfileCompletedAnim = 0;

    this.interval = setInterval(() => {
      if (this.employeeProfileCompletedAnim === endVal) {
        clearInterval(this.interval);
        return;
      }
      this.employeeProfileCompletedAnim++;
    }, 25)
  }
}